module.exports = __webpack_public_path__ + "img/MT.a2da5e79.svg";